import { memo } from 'react';

import type { GamingCardProps } from '@shared/Gaming';
import GamingBase from '@shared/Gaming';

const GamingCard = ({ options }: { options: GamingCardProps }) => <GamingBase {...options} />;

export default memo(GamingCard);
